<!--
 * @Author: Gaho
 * @Date: 2024-06-20 13:40:34
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-26 13:22:44
 * @Description: 全局公平性介绍窗口，在此呈现上局+本局的 seed 值 
-->
<template>
    <ModalMobile v-bind="$attrs" :model-value="modelValue" :backdrop="backdrop">
        <template #header>
            <span class="text-[24px] leading-10"> {{ t.Fainess }} </span>
        </template>
        <div class="flex text-white flex-col gap-2 justify-center">
            <div>{{ t.FainessMobileContent }}</div>
            <div class="form-item" v-if="nextRoundHash">
                <p class="">{{ t.MobileHashRound }}</p>
                <div class="gap-[8px]">
                    <q-input
                        v-model="nextRoundHash"
                        autogrow
                        readonly
                        filled
                        class="bg-[#090c1199] border-[#2a3546] border-[1px] rounded-[8px] flex-1"
                        @click="handleSelectAll"
                    />
                    <ButtonCopy
                        mode="normalContained"
                        class="flex items-center justify-center !w-[28px] !h-[28px] !m-0"
                        :value="nextRoundHash"
                    />
                </div>
            </div>
            <div>
                <h3 class="font-bold text-center">
                    {{ t.PreviousRoundsHistory }}
                </h3>
            </div>
            <!-- 
                ↑ 标题
                ↓ 各项内容 
            -->
            <div class="flex flex-col gap-2">
                <div class="form-item">
                    <p>{{ t.gameName }}</p>
                    <DropDown
                        v-if="gameDropOptions.options.length > 0"
                        class="flex-1"
                        v-model="gameDropOptions.value"
                        :options="gameDropOptions.options"
                        showOptionIcon
                        @update:model-value="handleSelectGame"
                    >
                        <template #prevIcon>
                            <IconSvgUse
                                :use="`icon-${gameDropOptions.value}`"
                                class="w-[20px] text-[#93ACD3FF] h-[20px]"
                            />
                        </template>
                    </DropDown>
                </div>
                <!-- 行分界 -->
                <template v-if="idDropOptions.options.length > 0">
                    <div class="form-item">
                        <p>{{ t.GameDetails.BetId }}</p>
                        <DropDown
                            class="flex-1"
                            v-model="idDropOptions.value"
                            :options="idDropOptions.options"
                            @update:model-value="handleSelectId"
                        />
                    </div>
                    <div class="form-item">
                        <p>{{ t.RandomSeed }}</p>
                        <div class="gap-[8px]">
                            <Input
                                readonly
                                :model-value="randomSeed"
                                class="flex-1"
                                :containerCalss="'grow'"
                                @click="handleSelectAll"
                            >
                            </Input>
                            <ButtonCopy
                                mode="normalContained"
                                class="!p-1 m-auto flex items-center justify-center !w-[28px] !h-[28px] !m-0"
                                :value="randomSeed"
                            />
                        </div>
                    </div>
                    <div class="form-item">
                        <p>{{ t.HashRound }}</p>
                        <div class="gap-[8px]">
                            <q-input
                                v-model="hashRound"
                                autogrow
                                readonly
                                filled
                                class="bg-[#090c1199] border-[#2a3546] border-[1px] rounded-[8px] flex-1"
                                @click="handleSelectAll"
                            />
                            <ButtonCopy
                                mode="normalContained"
                                class="flex items-center justify-center !w-[28px] !h-[28px] !m-0"
                                :value="hashRound"
                            />
                        </div>
                    </div>
                </template>
                <Empty v-else class="!mb-0"></Empty>
            </div>
        </div>
        <!-- 
            ↓ 下方按钮 
        -->
        <template #footer>
            <Button @click="onHowItWorks" class="primaryContained text-white h-[45px] flex-1">
                {{ t.FairnessPrinciple }}
            </Button>
            <Button @click="onCheck" class="primaryContained text-white h-[45px] flex-1">
                {{ t.Check }}
            </Button>
        </template>
    </ModalMobile>
</template>


<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import useTranslation from '~/i18n/useTransLation';
// socket
import { useGameHistorySocket } from '~/socket/gamehistory';
// stores
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useGameIdListStore } from '~/stores/cansino/gameIdList';
import { aGamesWithoutHash } from '@/common/js/gameAbout';
import 'quasar/src/components/input/QInput.sass'; 

const joinStateStore = useJoinStateStore();
const gameIdListStore = useGameIdListStore();
const { EMIT_GET_HISTORY } = useGameHistorySocket();
const { hash: nextRoundHash } = storeToRefs(joinStateStore);
const t = useTranslation();
const randomSeed = ref('randomSeed');
const hashRound = ref('hashRound');
const historyData = ref([]);
const idDropOptions = reactive({
    value: '0',
    options: [],
});

const gameDropOptions = reactive({
    value: '',
    options: [], // 下方赋值 
});


const props = defineProps({
    modelValue: Boolean,
    backdrop: {
        type: Boolean,
        default: true,
    },
});
const emit = defineEmits(['handleClose', 'handlePrinciple']);

/**
 * 选项初始化的方法
 */
const setOptions = (
    aList=null,
) => {
    aList ||= gameIdListStore.gameIdNameList; 
    if (!aList.length || gameDropOptions.options.length) {
        return; 
    }
    gameDropOptions.options = aList.flatMap((item) => {
        if (aGamesWithoutHash.includes(item.name)){
            return []; // 排除这些没有 hash 值的游戏  
        }
        return {
            ...item,
            value: item.name,
            name: t[item.title],
        };
    });
};

/**
 * 检查，跳转打开hash校验页面
 */
const onCheck = () => {
    const address = import.meta.env.VITE_SHA265_CHECK_PAGE_URL;
    const message = randomSeed.value;
    const url = `${address}/?message=${message}`;
    console.log('open page:', url); 
    window.open(url, '_blank');
};

/**
 * 如何运作
 */
const onHowItWorks = async () => {
    emit('handleClose', false);
    emit('handlePrinciple');
};

/**
 * 切换游戏查询history,更新对应的Random Seed和Hash Round
 * @param value game name
 */
const handleSelectGame = (value) => {
    const gameId = gameDropOptions.options.find((game) => game.value === value).id;
    handleEmitGetHistory(gameId.toString());
};
/**
 * 切换id 更新对应的Random Seed和Hash Round
 * @param value 下标
 */
const handleSelectId = (value) => {
    randomSeed.value = historyData.value[value].randomSeed;
    hashRound.value = historyData.value[value].hash;
};
/**
 * emit history
 * @param gameId 游戏id
 */
const handleEmitGetHistory = (gameId: string) => {
    EMIT_GET_HISTORY({ game: gameId, category: 'dapps', page: 1, status: 1 }, (res) => {
        if (res?.response?.length) {
            randomSeed.value = res.response[0].randomSeed;
            hashRound.value = res.response[0].hash;
            historyData.value = res.response;
            idDropOptions.options = [];
            idDropOptions.value = '0';
            res.response.forEach((element, index) => {
                if (index < 10) {
                    idDropOptions.options.push({
                        name: String(element._id),
                        value: String(index),
                    });
                }
            });
        } else {
            idDropOptions.options = [];
        }
    });
};
/**
 * 点击输入框，全选内容
 * @param e
 */
const handleSelectAll = (e) => {
    const currentDom = e.target;
    currentDom.setSelectionRange(0, currentDom.value.length);
};

// 监听弹框显示隐藏
watch(
    () => props.modelValue,
    (value) => {
        if (!value) return;
        const gameId = joinStateStore.gameId.toString();
        const oTarget = gameIdListStore.gameIdNameList.find((game) => {
            return game.id === joinStateStore.gameId;
        });
        gameDropOptions.value = oTarget?.name || '';
        handleEmitGetHistory(gameId);
    },
);


watch(
    () => gameIdListStore.gameIdNameList,
    setOptions,
    {
        deep: true, 
        immediate: import.meta.client,
    },
);

onMounted(()=>{
    setOptions();
});

</script>


<style lang="scss" scoped>
.form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > p {
        flex: 0.8;
        font-size: 12px;
    }
    > div {
        flex: 2.2;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    :deep(textarea) {
        color: white;
        padding: 6px 0;
    }
}
</style>
